(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activate(root, index) {
    var url = '';
    root.querySelectorAll('.hdt-ctabs__tab').forEach(function (tab) {
      var on = tab.dataset.index === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
      if (on) url = tab.dataset.url || '';
    });
    root.querySelectorAll('.hdt-ctabs__panel').forEach(function (panel) {
      panel.hidden = panel.dataset.index !== index;
    });
    if (url) {
      root.querySelectorAll('[data-ctabs-link]').forEach(function (link) {
        link.setAttribute('href', url);
      });
    }
    root.dispatchEvent(new CustomEvent('hdt:ctabs:change', { bubbles: true, detail: { index: index } }));
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.hdt-ctabs__tab');
    if (!tab) return;
    var root = tab.closest('.hdt-ctabs');
    if (!root || tab.classList.contains('is-active')) return;
    activate(root, tab.dataset.index);
  });

  document.addEventListener('keydown', function (event) {
    if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(event.key) === -1) return;
    var tab = event.target.closest('.hdt-ctabs__tab');
    if (!tab) return;
    var root = tab.closest('.hdt-ctabs');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.hdt-ctabs__tab'));
    var i = tabs.indexOf(tab);
    var next =
      event.key === 'Home' ? 0 :
      event.key === 'End' ? tabs.length - 1 :
      event.key === 'ArrowRight' ? (i + 1) % tabs.length :
      (i - 1 + tabs.length) % tabs.length;
    event.preventDefault();
    tabs[next].focus();
    activate(root, tabs[next].dataset.index);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testmonial-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function step(track) {
    var item = track.querySelector('.hdt-tmn__item');
    if (!item) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function sync(root) {
    var track = root.querySelector('[data-tmn-track]');
    var prev = root.querySelector('[data-tmn-prev]');
    var next = root.querySelector('[data-tmn-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tmn-prev],[data-tmn-next]');
    if (!btn) return;
    var root = btn.closest('.hdt-tmn');
    var track = root.querySelector('[data-tmn-track]');
    var dir = btn.hasAttribute('data-tmn-next') ? 1 : -1;
    track.scrollBy({ left: step(track) * dir, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track.classList || !track.classList.contains('hdt-tmn__track')) return;
    sync(track.closest('.hdt-tmn'));
  }, true);

  function initAll() {
    document.querySelectorAll('.hdt-tmn').forEach(sync);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', initAll);
  initAll();
})();

  } catch(e) { console.error(e); }
})();
})();
